import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { AudioRecorder } from "react-audio-voice-recorder";
import CloseIcon from "@mui/icons-material/Close";
import MicIcon from "@mui/icons-material/Mic";
import { audioupload } from "../../components/funtionsBD/Mainservice";
import "../coach/ExerciseFeedback.css";
import "./LiveTrainingFeedbackSheet.css";

export function LiveTrainingCoachVoiceHold({
  open,
  playerName,
  receiverUserId,
  socket,
  teId,
  tsId,
  senderUserId,
  onClose,
  onFeedbackSent,
  brandPrimary = "#0877BC",
}) {
  const { t } = useTranslation();
  const [uploading, setUploading] = useState(false);

  if (!open || !receiverUserId || typeof document === "undefined") return null;

  const sendVoice = async (blob) => {
    if (!blob || uploading || !socket || !teId || !senderUserId) return;
    setUploading(true);
    try {
      const params = new FormData();
      params.append("voiceMessage", new Blob([blob], { type: "audio/mpeg" }));
      const response = await audioupload(params);
      socket.emit("sendMessage", {
        te_id: teId,
        ts_id: tsId,
        sender_id: senderUserId,
        receiver_id: receiverUserId,
        message_type: "voice",
        text_message: null,
        voice_message_url: response.data.data,
      });
      onFeedbackSent?.({
        receiverUserId,
        messageType: "voice",
        voiceMessageUrl: response.data.data,
      });
      onClose?.();
    } catch (error) {
      console.error("coach voice hold upload failed:", error);
    } finally {
      setUploading(false);
    }
  };

  const portalStyle = {
    "--brand-primary": brandPrimary,
    "--lt-brand": brandPrimary,
  };

  return createPortal(
    <div
      className="lt-fb-voice-hold-portal"
      style={portalStyle}
      role="presentation"
      onClick={onClose}
    >
      <div
        className="lt-fb-voice-hold"
        role="dialog"
        aria-modal="true"
        aria-label={t("liveTrainingFeedbackVoiceHoldTitle")}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="fb-conv-header">
          <div className="fb-conv-header__avatar">
            <MicIcon fontSize="small" />
          </div>
          <div>
            <p className="fb-conv-header__name">
              {t("liveTrainingFeedbackVoiceHoldTitle")}
            </p>
            <p className="fb-conv-header__label">
              {t("liveTrainingFeedbackVoiceHoldSub", {
                name: playerName || t("player"),
              })}
            </p>
          </div>
          <button
            type="button"
            className="lt-fb-sheet__close"
            onClick={onClose}
            aria-label={t("close")}
          >
            <CloseIcon fontSize="small" />
          </button>
        </header>
        <p className="lt-fb-voice-hold__hint">
          {t("liveTrainingFeedbackVoiceHoldHint")}
        </p>
        <div className="lt-fb-voice-hold__composer fb-composer">
          <AudioRecorder
            onRecordingComplete={sendVoice}
            audioTrackConstraints={{
              noiseSuppression: false,
              echoCancellation: false,
            }}
            downloadOnSavePress={false}
            showVisualizer
            downloadFileExtension="webm"
          />
        </div>
        {uploading ? (
          <p className="lt-fb-sheet__uploading" role="status">
            {t("loading") || "Uploading…"}
          </p>
        ) : null}
      </div>
    </div>,
    document.body
  );
}

export default LiveTrainingCoachVoiceHold;
